import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FormBuilder, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {AuthService} from '../auth.service';
import {Router} from '@angular/router';
import {MatMenuTrigger} from '@angular/material/menu';
import {SnackService} from '../../shared/components/snack/snack.service';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss']
})

export class DeleteUserComponent implements OnInit {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  fb = inject(FormBuilder);
  _translate = inject(TranslateService);
  _auth = inject(AuthService);
  _router = inject(Router);
  showPasswordText: boolean = true;
  deleteForm = this.fb.nonNullable.group({
    userId: ['',Validators.required],
    password: ['',Validators.required],
    deleteReason: ['',Validators.required]
  })
  constructor(private _snack: SnackService,) { }

  ngOnInit(): void {
  }
  changeLanguage() {
    const lang = this._translate.currentLang === 'en' ? 'ar' : 'en';
    this._translate.use(lang);
    localStorage.setItem('LANG', lang);
    location.reload();
    this.trigger.closeMenu();
  }

  onSubmit() {
    let result = null;
    this._auth.deleteAccount(this.deleteForm.value).subscribe((res) => {
        result = res ;
      },
      ({ error }) => {},
      () => {
        if(result && result.success){
          this._snack.showSnack('COMMON.SEND_SUCCESS', 'success');
        }
      }
    )
  }
}
